import axios from "./axios";
import { setHeaders } from "./baseApi";
import { apiPaths } from "./baseApi";
/**
 * @param {string} [context] - Contexte facultatif
 * @returns {Promise<any>}
 */

export const generateDiplomesByDecision = async (idDecision, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/diplome/create`,
    { id_decision: idDecision },
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

export const generateNewDiplome = async (idDecision, idDiplome, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/diplome/generateDiplomeFromCancelledPDF`,
    {
      id_decision: idDecision,
      id_diploma: idDiplome,
    },
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

export const generateDiplomeDuplicata = async (idDiplome, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/duplicata/create`,
    { id_diploma: idDiplome },
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

export const getDiplomeFile = async (id, entity, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/diplome/getfile/${id}/${entity}`,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

export const getDiplomeStat = async (context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/diplome/diplomaGenerate`,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

export const getAllDiplomesByDecision = async (id, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/diplome/decision/all/${id}`,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

export const getDiplomeById = async (id, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/diplome/Byid/${id}`,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

export const cancelDiplome = async (id, payload, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/diplome/cancel/${id}`,
    payload,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

export const updateDiplome = async (id, context) => {
  const response = await axios.put(apiPaths.baseUrl + `/api/diplome/${id}`, {
    headers: setHeaders(context),
  });
  return response.data;
};

export const regenerateDiplome = async (id, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/diplome/regenerate/${id}`,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

export const getAllDecisions = async (context) => {
  const response = await axios.get(apiPaths.baseUrl + `/api/decision/all`, {
    headers: setHeaders(context),
  });
  return response.data;
};

export const getDecisionById = async (id, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/decision/getById/${id}`,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

export const getDecisionParameter = async (context) => {
  const response = await axios.get(
    apiPaths.baseUrl +
      `/api/decisionParameter/get/8b153dd8-6436-4388-9201-3a1c5bce4504`,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

export const updateDecisionParameter = async (payload, context) => {
  const response = await axios.put(
    apiPaths.baseUrl +
      `/api/decisionParameter/update/8b153dd8-6436-4388-9201-3a1c5bce4504`,
    payload,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

// créer une décision
export const createDecision = async (context) => {
  const response = await axios.post(apiPaths.baseUrl + `/api/decision/create`, {
    headers: setHeaders(context),
  });
  return response.data;
};

export const createDecisionStudent = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/decisionStudent/create`,
    payload,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

export const deleteDecisionStudent = async (id, context) => {
  const response = await axios.delete(
    apiPaths.baseUrl + `/api/decisionStudent/delete/${id}`,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

export const deleteDecisionValidation = async (id, context) => {
  const response = await axios.delete(
    apiPaths.baseUrl + `/api/decisionValidation/delete/${id}`,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

export const createDecisionValidation = async (formData, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/decisionValidation/create`,
    formData,
    {
      headers: {
        ...setHeaders(context),
        "Content-Type": "multipart/form-data",
      },
    },
  );
  return response.data;
};

export const createDiplomeValidation = async (formData, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/diplomaValidation/create`,
    formData,
    {
      headers: {
        ...setHeaders(context),
        "Content-Type": "multipart/form-data",
      },
    },
  );
  return response.data;
};

// modifier une décision
export const updateDecision = async (id, payload, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/decision/update/${id}`,
    payload,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

// supprimer une décision
export const deleteDecision = async (id, context) => {
  const response = await axios.delete(
    apiPaths.baseUrl + `/api/decision/delete/${id}`,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

export const generateDecisionPDF = async (id, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/pdf/decision/${id}`,
    {
      headers: setHeaders(context),
      responseType: "blob",
    },
  );
  return response.data;
};

export const verifyDiplome = async (verification_code, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/diplome/verify`,
    {
      verification_code: verification_code,
    },
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};
